import { AIAgentDefinitions } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
export const keyFn = (searchParams) => ["aiagent", "workflow-definitions", searchParams];
export const fetchWorkflowDefinitions = (searchParams) => AIAgentDefinitions.paginated(
  searchParams.page,
  searchParams.pageSize,
  searchParams.sort.attributeId,
  searchParams.sort.direction,
  searchParams.query,
  FiltersForQueryParams(searchParams.filters)
).then(({ elements, attributes, query, pagination: { count, total, page, per_page: perPage } }) => ({
  list: elements,
  attributes,
  pagination: {
    count,
    total,
    page,
    perPage,
    query
  }
}));
const useWorkflowDefinitions = () => ({
  fetchWorkflowDefinitions,
  keyFn
});
export default useWorkflowDefinitions;
